import {
    ChonkyActions,
    FileBrowser,
    FileContextMenu,
    FileHelper,
    FileList,
    FileNavbar,
    FileToolbar,
    setChonkyDefaults,
} from "chonky";
import { ChonkyIconFA } from "chonky-icon-fontawesome";
import { useCallback, useEffect, useMemo, useState,useRef } from "react";
import { getFileBrowser } from "../../utils/Api";
import { handleLoaderEvent } from "../../utils/LoaderEmitter";
import MetaDataModal from "../MetaDataModal/MetaDataModal";
import UploadDocsModal from "../UploadDocsModal/UploadDocsModal";


setChonkyDefaults({ iconComponent: ChonkyIconFA });

const DocumentBrowser = ({ containerName }) => {
    const [FileSystem, setFileSystem] = useState();
    const [rootFolderId, setRootFolderId] = useState(null);
    const [fileMap, setFileMap] = useState(null);
    const [currentFolderId, setCurrentFolderId] = useState(rootFolderId);
    const [metaModalView, setMetaModalView] = useState(false);
    const [uploadDocsModalView, setUploadDocsModalView] = useState(false);
    const [selectedFileDetails, setSelectedFileDetails] = useState([]);
    const [filesMetadata, setFilesMetadata] = useState({});
    const [uploadDocsData,setUploadDocsData]=useState()


    const fileInputRef = useRef(null);

  const openFileExplorer = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileSelect = (event) => {
    const selectedFile = event.target.files[0];
    // console.log('Selected File:', selectedFile);
    setUploadDocsData(selectedFile)
    setUploadDocsModalView(true)
  };



    const metaModalClose = () => {
        setMetaModalView(false);
    };

    const uploadDocsModalClose = () => {
        setUploadDocsModalView(false);
    };
    const currentFolderIdRef = useRef(currentFolderId);

    useEffect(() => {
        (async () => {
            handleLoaderEvent.emit("loader", true);
            const documentDetails = await getFileBrowser(containerName);
            const files = documentDetails.body;
            const metadata = documentDetails.metadata;
            const parsedMetadata = {};
            for (let key in metadata) {
                if (metadata.hasOwnProperty(key)) {
                    // Create a new key by removing the '.docx' extension
                    let newKey = key.replace(".docx", "");

                    // Copy the value from the old key to the new key
                    parsedMetadata[newKey] = metadata[key];
                }
            }
            console.log(parsedMetadata);
            setFilesMetadata(parsedMetadata);
            setFileSystem(files);
            setRootFolderId(files?.rootFolderId);
            setFileMap(files?.fileMap);
            setCurrentFolderId(files?.rootFolderId);
            handleLoaderEvent.emit("loader", false);
        })();
    }, []);

    const useFiles = (currentFolderId) => {
        return useMemo(() => {
            if (currentFolderId) {
                const currentFolder = fileMap[currentFolderId];
                const files = currentFolder?.childrenIds
                    ? currentFolder.childrenIds.map(
                          (fileId) => fileMap[fileId] ?? null
                      )
                    : [];

                return files;

            }
        }, [currentFolderId, fileMap]);
    };

    const useFolderChain = (currentFolderId) => {
        return useMemo(() => {
            if (fileMap) {
                const currentFolder = fileMap[currentFolderId];
                const folderChain = [currentFolder];

                let parentId = currentFolder.parentId;
                while (parentId) {
                    const parentFile = fileMap[parentId];
                    if (parentFile) {
                        folderChain.unshift(parentFile);
                        parentId = parentFile.parentId;
                    } else {
                        parentId = null;
                    }
                }
                return folderChain;
            }
        }, [currentFolderId]);
    };

    const useFileActionHandler = (setCurrentFolderId) => {
        return useCallback(
            (data) => {
                if (data.id === ChonkyActions.OpenFiles.id) {
                    const { targetFile, files } = data.payload;
                    const fileToOpen = targetFile ?? files[0];
                    if (fileToOpen && FileHelper.isDirectory(fileToOpen)) {
                        setCurrentFolderId(fileToOpen.id);
                        return;
                    }
                }
                if (
                    data?.id === ChonkyActions.MouseClickFile.id &&
                    !data?.payload["file"]["isDir"]
                ) {
                    const fileName = data?.payload['file']['name']

                    const metaDataFieldNames=Object.keys(filesMetadata[fileName])
                    console.log(metaDataFieldNames)

                    let selectedFileMetaData =[]

                    metaDataFieldNames?.forEach((metadataFieldName)=>
                    {
                        let obj={}
                        let value=filesMetadata[fileName][metadataFieldName][0]
                        if(value!=null)
                        {
                            obj[metadataFieldName]=value
                            selectedFileMetaData.push(obj)
                        }

                    })

                    setSelectedFileDetails(selectedFileMetaData);
                    setMetaModalView(true);
                }
                if (data.id === ChonkyActions.UploadFiles.id)
                {

                    // openFilePicker()
                    openFileExplorer()


                }
            },
            [setCurrentFolderId, filesMetadata]
        );
    };
    const fileActions = useMemo(
        () => [
            ChonkyActions.UploadFiles,
        ],
        []
        // fileactions should be present only for Galderma container not for medinfo Container.
    );

    const handleFileAction = useFileActionHandler(setCurrentFolderId);
    const files = useFiles(currentFolderId);
    const folderChain = useFolderChain(currentFolderId);

    return (
        <div style={{ height: "90%" }} className="mt-4">
              <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />
            <MetaDataModal
                metaModalView={metaModalView}
                metaModalClose={metaModalClose}
                metaData={selectedFileDetails}
            ></MetaDataModal>
            <UploadDocsModal
                 uploadDocsModalView={uploadDocsModalView}
                 uploadDocsModalClose={uploadDocsModalClose}
                 docsData={uploadDocsData}
            ></UploadDocsModal>
            <FileBrowser
                files={files}
                folderChain={folderChain}
                onFileAction={handleFileAction}
                defaultFileViewActionId={ChonkyActions.EnableListView.id}
                fileActions={fileActions}
            >
                <FileNavbar />
                <FileToolbar />
                <FileList />
                <FileContextMenu />
            </FileBrowser>
        </div>
    );
};

export default DocumentBrowser;
